  <template>
  <div class="sign_up_detail-root">
    <div class="main-content-wrap">
      <yioks-page-nav @backBtnHandle="$router.go(-1)" class="nav-wrap">
        <p class="title">{{ signInfo.enroll_name }}</p>
        <div class="nav-right" slot="right"></div>
      </yioks-page-nav>
      <div class="loading_wrap pageLoading_top" v-show="pageLoading">
        <yioks-loading></yioks-loading>
      </div>
      <div class="sign_up-info-wrap">
        <div class="info-box">
          <div class="show-wrap">
            <img :src="levelLogo" class="picture" />
            <status-flag
              class="status-flat"
              :status="signInfo.enroll_status"
            ></status-flag>
          </div>
          <div class="detail-info">
            <p class="info-item" v-if="signInfo.enroll_level === 'E'">
              培训班级别：{{ signInfo.enroll_level | enrollLevel }}
            </p>
            <p class="info-item" v-else>
              培训班级别：{{ signInfo.enroll_level | enrollLevel }}
            </p>
            <p class="info-item" v-if="signInfo.time_change_way ==='month'">
              计划开班月份：<template
                v-if="signInfo.classPhase && signInfo.classPhase.length"
                >
              <span @click="showClassDetail = true" style="cursor:pointer;color:#4CD964">点击查看</span>
              <!--<span-->
                  <!--v-for="(item, index) in signInfo.classPhase"-->
                  <!--:key="index"-->
                  <!--class="range-item"-->
                  <!--&gt;{{ item.start_date | time(false, false) }} 至-->
                  <!--{{ item.end_date | time(false, false) }}</span>-->
            </template
              >
              <span v-else
                >{{ signInfo.class_start | time(false, false) }} 至
                {{ signInfo.class_end | time(false, false) }}</span
              >
            </p>
            <p class="info-item" v-if="signInfo.time_change_way ==='periods'">
              计划开班期数：<template
              v-if="signInfo.classPhase && signInfo.classPhase.length"
            >
              <span @click="showClassDetail = true" style="cursor:pointer;color:#4CD964">点击查看</span>
              <!--<span v-for="(item, index) in signInfo.classPhase" :key="index" class="range-item">第{{index+1}}期（阶段一：{{ item.start_date | time(false, false) }}，阶段二：-->
                  <!--{{ item.end_date | time(false, false) }}）</span>-->
            </template
            >
              <span v-else
              >{{ signInfo.class_start | time(false, false) }} 至
                {{ signInfo.class_end | time(false, false) }}</span
              >
            </p>
            <p class="info-item">
              报名时间：{{ signInfo.enroll_start | time(false) }} 至
              {{ signInfo.enroll_end | time(false) }}
            </p>
            <p class="info-item">
              报名人数：
              <span>
                {{ signInfo.personnelNum }}
              </span>
              <span v-if="signInfo.enroll_person_num !== 0">
                / {{ signInfo.enroll_person_num }}
              </span>
            </p>
            <p class="info-item">
              报名类型：{{ signInfo.enroll_type | enrollType }}
            </p>
            <p class="info-item" v-if="signInfo.enroll_type === 'continue_education' || signInfo.enroll_type === 'goalkeeper_education'">
              培训方式：{{ signInfo.train_way | enroll_train_way }}
            </p>
          </div>
        </div>
        <div class="btns_wrap" v-if="!['viewer','viewFive'].includes(localUserInfo.member_type)">
          <span class="zuxie-btn" @click="toEdit" v-if="showEdit"
            >编辑报名</span
          >
          <span
            class="zuxie-btn zuxie-btn-danger"
            @click="enrollClose('close')"
            v-if="signInfo.isShowClose === 1"
            >关闭报名</span
          >
          <span
            class="zuxie-btn zuxie-btn-danger"
            @click="enrollClose('open')"
            v-if="signInfo.isShowOpen === 1"
            >开启报名</span
          >
        </div>
      </div>
      <div class="deatil_main">
        <div class="scroll_wrap" v-if="!pageLoading">
          <vue-scroll :ops="vuescrollOpt" ref="vScroll">
            <div class="scroll-content">
              <div v-if="showChart" class="itemWrap">
                <div class="titleWrap">
                  <div class="title">
                    <v-icon
                      class="logo"
                      name="regular/envelope"
                      scale="1.8"
                    ></v-icon>
                    <p>注册报名人员统计</p>
                  </div>
                </div>
                <div class="chart_wrap">
                  <div class="pie" ref="pie"></div>
                  <div class="bar" ref="bar"></div>
                </div>
              </div>
              <template>
                <div class="itemWrap">
                  <div class="titleWrap">
                    <div class="title">
                      <v-icon
                        class="logo"
                        name="regular/clock"
                        scale="1.8"
                      ></v-icon>
                      <p>报名人员详情</p>
                    </div>
                  </div>
                  <div class="titleWrap" style="width: 850px">
                    <select
                      v-model="selectVal.org_id"
                      :class="[
                        'organSelect',
                        identity_list.length > 0
                          ? 'selectWith'
                          : 'selectWidth3',
                      ]"
                      @change="search"
                    >
                      <option value>全部机构</option>
                      <option
                        v-for="item in organList"
                        :value="item.org_id"
                        :key="item.org_abbreviation"
                      >
                        {{ item.org_abbreviation }}
                      </option>
                    </select>
                    <select
                      v-model="selectVal.matriculate_status"
                      @change="search"
                      :class="[
                        'organSelect',
                        identity_list.length > 0
                          ? 'selectWith'
                          : 'selectWidth3',
                      ]"
                    >
                      <option value>全部状态</option>
                      <option
                        v-for="item in statusList"
                        :value="item.value"
                        :key="item.value"
                      >
                        {{ item.key }}
                      </option>
                    </select>
                    <select
                      v-model="selectVal.intention_class_date"
                      @change="
                        handleIntentionChange(selectVal.intention_class_date)
                      "
                      v-if="signInfo.is_choose_classDate && signInfo.time_change_way === 'month'"
                      :class="[
                        'organSelect',
                        identity_list.length > 0
                          ? 'selectWith'
                          : 'selectWidth3',
                      ]"
                    >
                      <option value="">意向参加培训班时间</option>
                      <!-- <option
                        v-for="item in months"
                        :value="item"
                        :key="item"
                      >{{item}}</option> -->
                      <option
                        v-for="(item, index) in monthsList"
                        :key="index"
                        :value="item.value"
                      >
                        {{ item.label }}
                      </option>
                    </select>
                    <select
                      v-model="selectVal.intention_class_date"
                      @change="
                        handleIntentionChange(selectVal.intention_class_date)
                      "
                      v-if="signInfo.is_choose_classDate && signInfo.time_change_way === 'periods'"
                      :class="[
                        'organSelect',
                        identity_list.length > 0
                          ? 'selectWith'
                          : 'selectWidth3',
                      ]"
                    >
                      <option value="">意向参加培训班期数</option>
                      <!-- <option
                        v-for="item in months"
                        :value="item"
                        :key="item"
                      >{{item}}</option> -->
                      <option
                        v-for="(item, index) in periodsList"
                        :key="index"
                        :value="item.value"
                      >
                        {{ item.label }}
                      </option>
                    </select>
                    <select
                      v-model="selectVal.admit_status"
                      @change="handleAdmitStatus(selectVal.admit_status)"
                      :class="[
                        'organSelect',
                        identity_list.length > 0
                          ? 'selectWith'
                          : 'selectWidth3',
                      ]"
                    >
                      <option value="">关注度</option>
                      <option value="none_star">未评星</option>
                      <option
                        v-for="(item, index) in selectListForSignStu"
                        :key="index"
                        :value="item.value"
                      >
                        {{ item.key }}
                      </option>
                    </select>
                    <select
                      v-model="selectVal.identity_id"
                      @change="search"
                      v-if="signInfo.is_need_identity && identity_list.length > 0"
                      :class="[
                        'organSelect',
                        identity_list.length > 0
                          ? 'selectWith'
                          : 'selectWidth3',
                      ]"
                    >
                      <option value>全部身份</option>
                      <option
                        v-for="item in identity_list"
                        :value="item.identity_id"
                        :key="item.identity_name"
                      >
                        {{ item.identity_name }}
                      </option>
                    </select>
                    <select
                      v-model="selectVal.in_class"
                      @change="search"
                      :class="[
                        'organSelect',
                        identity_list.length > 0
                          ? 'selectWith'
                          : 'selectWidth3',
                      ]"
                    >
                      <option value>加入培训班</option>
                      <option
                        v-for="item in man_status_list"
                        :value="item.value"
                        :key="item.value"
                      >
                        {{ item.label }}
                      </option>
                    </select>
                    <select
                      v-model="selectVal.order_way"
                      @change="search"
                      :class="[
                        'organSelect',
                        identity_list.length > 0
                          ? 'selectWith'
                          : 'selectWidth3',
                      ]"
                    >
                      <option value>默认排序</option>
                      <option value="desc">分数降序</option>
                      <option value="asc">分数升序</option>
                    </select>
                    <div
                      v-if="signInfo.is_need_live_address"
                      class="live-address"
                    >
                      <el-popover
                        placement="bottom"
                        width="350"
                        v-model="isShowAddress"
                      >
                        <el-form :inline="true" ref="searchAddressForm" :model="searchAddressForm" label-width="80px">
                            <el-form-item label="省份">
                              <el-select v-model="searchAddressForm.province_id" clearable @change="updateCity" placeholder="请选择省份">
                                <el-option v-for="(item, index) in area_list" :key="index" :label="item.regionName" :value="item.id"></el-option>
                              </el-select>
                            </el-form-item>
                            <el-form-item label="市">
                              <el-select v-model="searchAddressForm.city_id" clearable placeholder="请选择市">
                                <el-option v-for="(item, index) in city_list" :key="index" :label="item.regionName" :value="item.id"></el-option>
                              </el-select>
                            </el-form-item>
                        </el-form>
                        <div class="btns-list">
                          <div class="btn suc" @click="handleSearchAddress">筛选</div>
                          <div class="btn primary" @click="handleClearSearchAddress">清除筛选</div>
                        </div>
                        <el-button type="text" slot="reference"
                          >现居住地</el-button
                        >
                        <!--<el-button type="primary"  slot="reference" icon="el-icon-search">空闲</el-button>-->
                      </el-popover>
                    </div>

                    <div class="search">
                      <div class="wrap yioks-wrapper">
                        <!-- <input type="text" placeholder="请输入搜索内容" v-model.lazy="selectVal.keywords">
                        <div v-show="selectVal.keywords!=''" class="close" @click="hideIcon">
                          <v-icon name="regular/times-circle" scale="1.2"></v-icon>
                        </div> -->
                        <el-autocomplete
                          class="inline-input"
                          v-model="selectVal.keywords"
                          :fetch-suggestions="querySearch"
                          placeholder="请输入搜索内容"
                          @keyup.enter.native="handleBtnSearch"
                          @select="handleSearch"
                        ></el-autocomplete>
                      </div>
                      <div class="searchBtn" @click="handleBtnSearch">搜索</div>
                    </div>


                  </div>
                  <div class="table" v-show="!isLoading">
                    <!-- v-if="peopleList.length" -->
                    <div class="empty_wrap" v-if="!peopleList.length">
                      <yioks-empty h="180px"></yioks-empty>
                    </div>
                    <div
                      class="item"
                      v-for="(item, index) in peopleList"
                      :key="index"
                    >
                      <div class="row up">
                        <div class="col user">
                          <div class="imgWrap" @click="() => {}">
                            <!-- debugger -->
                            <div class="img-wrap">
                              <img
                                :src="item.profile_picture || User"
                                @error="userImgError(index)"
                              />
                              <span
                                class="suc-color btn-text"
                                @click="loadAuditLog(item)"
                                >审核记录</span
                              >
                            </div>
                            <status-flag
                              class="status-flat"
                              :status="item.matriculate_status"
                            ></status-flag>
                          </div>
                          <div class="wrap">
                            <p class="name">{{ item.name }}<span v-if="item.is_high_player" style="color:#FAF408;font-weight:bold" title="高水平职业球员认证"> (G)</span>（<span style="color:#4CD964;cursor:pointer" @click="ShowScoreList(item)">{{item.total_score || '--'}}分</span>）</p>
                            <p
                              v-if="item.admit_c_id"
                              style="color: #4cd964; cursor: pointer"
                              @click="jumpLookClass(item.admit_c_id)"
                            >
                              查看培训班
                            </p>
                            <div style="display: flex; align-items: center" v-if="!['viewer','viewFive'].includes(localUserInfo.member_type)">
                              <p
                                v-if="
                                  if_has_audit_btn(item) && !item.admit_c_id
                                "
                                @click="verify(item.user_id)"
                                style="color: #4cd964; cursor: pointer"
                              >
                                审核
                              </p>
                              <p
                                style="margin: 0 5px"
                                v-if="
                                  if_has_audit_btn(item) &&
                                  if_has_class_btn(item) &&
                                  !item.admit_c_id
                                "
                              >
                                /
                              </p>
                              <p
                                v-if="
                                  if_has_class_btn(item) && !item.admit_c_id
                                "
                                @click="addClass(item)"
                                style="color: #4cd964; cursor: pointer"
                              >
                                加入培训班
                              </p>
                            </div>
                          </div>
                        </div>
                        <div class="col info">
                          <div class="title">
                            <p>基</p>
                            <p>本</p>
                            <p>信</p>
                            <p>息</p>
                          </div>
                          <div class="block">
                            <div class="line">
                              <p>证件号：{{ item.id_number }}</p>
                            </div>
                            <div class="line">
                              <p>
                                <span>性别：{{ item.gender | getGender }}</span>
                                <span>手机号：{{ item.mobile_phone }}</span>
                              </p>
                            </div>
                          </div>
                        </div>
                        <!--<div class="col note">-->
                        <!--<div class="title">-->
                        <!--<p>报</p>-->
                        <!--<p>名</p>-->
                        <!--<p>信</p>-->
                        <!--<p>息</p>-->
                        <!--</div>-->
                        <!--<div class="text">-->
                        <!--<p>{{item.student_information}}</p>-->
                        <!--</div>-->
                        <!--</div>-->
                        <div class="col grade info">
                          <div class="title">
                            <p>注</p>
                            <p>册</p>
                            <p>协</p>
                            <p>会</p>
                          </div>
                          <div class="gradeStatus">
                            <p>{{ item.org_abbreviation || "--" }}</p>
                          </div>
                        </div>
                        <div class="col grade" style="width: 20%">
                          <div class="title">
                            <p>关</p>
                            <p>注</p>
                            <p>度</p>
                          </div>
                          <div class="gradeStatus">
                            <el-select
                              v-model="item.admit_status"
                              size="small"
                              class="select-admit"
                              placeholder="请选择状态"
                              clearable
                              @change="handleChangeStuAdminStatus(item, index)"
                              :disabled="['viewer','viewFive'].includes(localUserInfo.member_type)"
                            >
                              <!-- <el-option value="" label="请选择"></el-option> -->
                              <el-option
                                v-for="item in selectListForSignStu"
                                :key="item.value"
                                :label="item.key"
                                :value="item.value"
                              >
                              </el-option>
                            </el-select>
                          </div>
                        </div>
                        <div class="col look">
                          <div
                            class="btn"
                            style="
                              margin-bottom: 10px;
                              width: 80px;
                              text-align: center;
                            "
                            @click="lookSignUp(item.uid)"
                          >
                            报名信息
                          </div>
                          <div class="btn" @click="tranHisView(item.uid)">
                            培训历程
                          </div>
                        </div>
                      </div>
                      <div class="row down" v-if="signInfo.is_choose_classDate && signInfo.time_change_way === 'month'">
                        <!-- <span class="remember">
                          意向参加培训班月份：{{item.intention_class_date | intentionClassDate}}
                        </span> -->
                        <span class="remember">
                          第一志愿：{{ item.intention_class_date_one }}
                        </span>
                        <span
                          class="remember"
                          v-if="item.intention_class_date_two"
                        >
                          第二志愿：{{ item.intention_class_date_two }}
                        </span>
                      </div>
                      <div class="row down" v-if="signInfo.is_choose_classDate && signInfo.time_change_way === 'periods'" style="display:grid">
                        <!-- <span class="remember">
                          意向参加培训班月份：{{item.intention_class_date | intentionClassDate}}
                        </span> -->
                        <span class="remember">
                          第一志愿：{{ item.intention_class_periods_one | intention_class_date_periods_filter }}
                        </span>
                        <span
                          class="remember"
                          v-if="item.intention_class_periods_two"
                        >
                          第二志愿：{{ item.intention_class_periods_two | intention_class_date_periods_filter }}
                        </span>
                      </div>
                      <div class="row down" v-if="item.enroll_num">
                        <span class="remember"
                          >未录取次数：{{ item.enroll_num }}次</span
                        >
                      </div>
                      <div class="row down tag-wrapper" v-if="!['viewer','viewFive'].includes(localUserInfo.member_type)">
                        <span class="remember flex-center">备注：</span>
                        <div class="tag-box">
                          <el-tag
                            class="tag-item"
                            v-for="(
                              admitNoteitem, admitNoteIndex
                            ) in item.admit_note"
                            :key="admitNoteIndex"
                            type="success"
                            closable
                            :disable-transitions="true"
                            hit
                            size="small"
                            effet="plain"
                            @close="handleClose(item, admitNoteIndex)"
                            >{{ admitNoteitem }}</el-tag
                          >
                          <el-input
                            class="input-new-tag"
                            v-if="item.inputVisible"
                            v-model="item.inputValue"
                            ref="saveTagInput"
                            size="small"
                            @keyup.enter.native="
                              handleInputConfirm(item, index)
                            "
                            @blur="handleInputConfirm(item, index)"
                          >
                          </el-input>
                          <el-button
                            v-else
                            class="button-new-tag"
                            size="small"
                            @click="showInput(item, index)"
                            >+ 新增</el-button
                          >
                        </div>
                      </div>
                      <!--                      <div class="row down" v-if="signInfo.enroll_type==='common' && (item.is_not_score_stu ===1 || item.is_score_unusual_stu ===1 || item.is_license_expired ===1)">-->
                      <!--                        <span class="remember">-->
                      <!--                          备注：{{item.is_not_score_stu | tipMsg(item.is_score_unusual_stu,item.is_license_expired)}}-->
                      <!--                        </span>-->
                      <!--                      </div>-->
                    </div>
                  </div>
                  <div class="loading_wrap" v-show="isLoading">
                    <yioks-loading></yioks-loading>
                  </div>
                </div>
                <yioks-paging
                  :paging="paging"
                  @goto-page="gotoPage($event)"
                ></yioks-paging>
              </template>
              <div class="itemWrap">
                <div class="titleWrap">
                  <div class="title">
                    <v-icon
                      class="logo"
                      name="regular/address-book"
                      scale="1.8"
                    ></v-icon>
                    <p>说明及附件</p>
                  </div>
                </div>
                <div class="classInfo">
                  <div class="row">
                    <div class="col">
                      <template v-if="signInfo.enroll_content">
                        <p class="intro">说明：</p>
                        <p v-html="signInfo.enroll_content"></p>
                      </template>
                      <template v-else>
                        <p>说明：--</p>
                      </template>
                    </div>
                  </div>
                  <div class="row" v-if="documentDate.length">
                    <p>附件：</p>
                    <div class="col" v-for="(file, i) in documentDate" :key="i">
                      <span
                        @click="downloadFile(file.document_address)"
                        class="downfile"
                        >{{ i + 1 }}：{{ file.document_title }}</span
                      >
                    </div>
                  </div>
                </div>
              </div>
              <div class="itemWrap" v-if="linkmenData.length">
                <div class="titleWrap">
                  <div class="title">
                    <v-icon
                      class="logo"
                      name="user-friends"
                      scale="1.8"
                    ></v-icon>
                    <p>报名联系人</p>
                  </div>
                </div>
                <div class="connect">
                  <div
                    class="row"
                    v-for="item in linkmenData"
                    :key="item.linkman_id"
                  >
                    <div class="col name">
                      <p>姓名：{{ item.name || "--" }}</p>
                    </div>
                    <div class="col phone">
                      <p>电话：{{ item.mobile_phone || "--" }}</p>
                    </div>
                    <div class="col email">
                      <p>邮箱：{{ item.email || "--" }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </vue-scroll>
        </div>
      </div>
      <yioks-verify
        :flag="isShowFlag"
        :verifyBtn="true"
        :is_show_btn_o="false"
        :is_info_request="false"
        :holderText="`如审核拒绝，可在此输入理由`"
        @hideVerify="hideVerifyDialog"
      ></yioks-verify>
      <yioks-tips
        :tips="update.msg"
        :showTips="verifyFlag"
        :loading="update.btnLoading"
        @hideTips="hideUploadTips"
      ></yioks-tips>
      <template v-if="ifDiaShow">
        <el-dialog
          class="detail-info-dia"
          title="详细信息"
          :visible.sync="ifDiaShow"
          :close-on-click-modal="false"
          width="750px"
          top="12vh"
        >
          <div class="scroll-wrap">
            <vue-scroll :ops="disScrollOpt" ref="vScroll">
              <div class="stu-info-box">
                <stu-detail-info :info="curStuInfo"></stu-detail-info>
              </div>
            </vue-scroll>
          </div>
        </el-dialog>
      </template>
      <template v-if="showAddClass">
        <el-dialog
          class="detail-info-dia"
          title="加入培训班"
          :visible.sync="showAddClass"
          :close-on-click-modal="false"
          width="520px"
          top="12vh"
        >
          <el-form :model="class_obj" ref="classForm">
            <el-form-item
              prop="c_id"
              label="培训班名称"
              label-width="100px"
              :rules="[
                {
                  required: true,
                  validator: (rule, value, callback) => {
                    classRule(rule, value, callback);
                  },
                  trigger: 'change',
                },
              ]"
            >
              <el-select
                v-model="class_obj.c_id"
                placeholder="请选择需要加入的培训班"
                style="width: 100%"
              >
                <el-option
                  v-for="(item, index) in classList"
                  :key="index"
                  :label="
                    item.is_special_train ? '【快】' + item.name : item.name
                  "
                  :value="item.c_id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <div
            class="classBtns"
            style="display: flex; justify-content: center; margin-top: 80px"
          >
            <el-popover placement="top" width="160" v-model="visible">
              <p>确定加入培训班吗？</p>
              <div style="text-align: right; margin: 0">
                <el-button type="primary" size="mini" @click="submitClass"
                  >确定</el-button
                >
                <el-button
                  size="mini"
                  style="background-color: red"
                  type="danger"
                  @click="
                    visible = false;
                    showAddClass = false;
                  "
                  >取消</el-button
                >
              </div>
              <el-button
                slot="reference"
                type="primary"
                @click="visible = true"
                :loading="classBtnLoaing"
                :disabled="classBtnLoaing"
                >加入培训班</el-button
              >
            </el-popover>
          </div>
        </el-dialog>
      </template>
      <template v-if="showHistory">
        <yioks-history
          :showHistory.sync="showHistory"
          :coachHistoryInfo="coachHistoryInfo"
          :loading="historyLoading"
          :list="list"
        ></yioks-history>
      </template>
      <template v-if="isShowAuditLog">
        <stu-log
          :isShow.sync="isShowAuditLog"
          :logList="auditLogList"
          @handleCloseBefore="handleLogCallBack"
        ></stu-log>
      </template>
      <template v-if="isShowScoreList">
        <stu-score-list
          :isShow.sync="isShowScoreList"
          :stuInfo="showScoreUserId"
        ></stu-score-list>
      </template>
      <class-info-detail
        v-if="showClassDetail"
        :isShow.sync="showClassDetail"
        :time_change_way="signInfo.time_change_way"
        :dataPhase="signInfo.classPhase"
      ></class-info-detail>
    </div>
  </div>
</template>

<script>
import levelA from "@/assets/images/enrollLogo_a.png";

import levelB from "@/assets/images/enrollLogo_b.png";
import levelPro from "@/assets/images/enrollLogo_pro.png";
import "vue-awesome/icons/regular/address-book";
import "vue-awesome/icons/regular/clock";
import "vue-awesome/icons/user-friends";
import "vue-awesome/icons/regular/envelope";
import echarts from "echarts/lib/echarts";
import "echarts/lib/chart/pie"; // 饼图
import "echarts/lib/chart/bar"; // 柱状图
import "echarts/lib/component/tooltip"; // 提示框组件
import "echarts/lib/component/title"; // 标题组件
import "echarts/lib/component/legend"; // 标签组件
import User from "@/assets/images/person.png";
import momentCover from "@/assets/images/class_logo.png";
import { classLevelForNewUser, enroll_type,enroll_train_way } from "@/assets/js/status";
import { area_list } from "@/assets/js/region";
import { experienceFilter,intention_class_date_periods_filter } from "@/assets/js/yioksFilters";

import {
  signUpDetail,
  signUpPeoples,
  orgList,
  signUpChart,
  enrollClose,
  examPersonnelCheck,
  noStartClassTrainList,
  getStuHistoryTrian,
  add_student_toClass,
  add_tags,
  toggle_admit_status,
  findAuditLogForSys,
} from "@/api/system_manager/api";
import createScrollOpt from "@/assets/js/vuescrollOption";
import { info_view, personnel_identity_data } from "@/api/ab_signup/api";
import commonFun from "@/assets/js/yioks";
import { statusKV } from "@/assets/js/status";
import identify1 from "@/assets/images/vita/identify1.png";
import identify2 from "@/assets/images/vita/identify2.png";
import avatorImg from "@/assets/images/person.png";
import {
  manager_status,
  personnelStatus,
  personnelExamStatus,
  selectListForSignStu,
} from "@/assets/js/select";
import levelLogo from "@/assets/images/footballAssociation.png";
const HOSTURL = process.env.VUE_APP_URL;
const { downfile } = commonFun;
import yioksStorage from "@/assets/js/yioksStorage";

const chartXArr = [
  "会员协会审核中",
  "会员协会拒绝",
  "会员协会推荐",
  "报名审核拒绝",
  "报名审核通过",
  // "中国足协已录取",
  // "中国足协未录取",
];
const newChartXArr = [
  // "中国足协已录取",
  // "中国足协未录取",
  "补考申请待处理",
  "补考审核通过",
  "补考审核拒绝",
];
const colorArr = [
  "#08cbfe",
  "#ff5722",
  "#ffeb38",
  "#d48265",
  "#4cd964",
  "#9B30FF",
  "#ff0302",
  "#f88594",
];
const newColorArr = ["#9B30FF", "#ff0302", "#f88594", "#4cd964", "#d48265"];

const SELECTSUGGESTIONlIST = "suggestionList";

export default {
  name: "sign-up-detail",
  components: {
    "yioks-page-nav": () => import("@/components/PageNav/PageNav"),
    "yioks-loading": () => import("@/components/Loading/Loading"),
    "v-icon": () => import("vue-awesome/components/Icon"),
    "yioks-paging": () => import("@/components/Pagination/Page"),
    "yioks-tips": () => import("@/components/Tips/Dialog"),
    "stu-detail-info": () =>
      import("@/components/EnrollPersonnelInfo/EnrollPersonnelInfo"),
    "status-flag": () => import("@/components/Tips/Status"),
    "yioks-empty": () => import("@/components/Tips/Empty"),
    // "yioks-verify": () => import("@/components/Tips/verify-adjust"),
    "yioks-verify": () => import("@/components/Tips/verify-adjust-applay"),
    "yioks-history": () => import("@/components/History/history"),
    "stu-log": () => import("@/components/AuditLog/StuAuditLogInSys"),
    "stu-score-list": () => import("@/components/Drawer/stu_info_score_list"),
    "class-info-detail": () => import("@/components/ClassInfoBox/EnrollClassPhaseDetail"),
  },
  created() {
    this.setData(); // 2
    this.getOrganList();
    this.getDeatilInfo();
    this.getPeoples();
  },
  data() {
    const classRule = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请选择需要加入的培训班"));
      } else if (this.classErrorFlag) {
        this.classErrorFlag = false;
        callback(new Error(this.classErrorMsg));
      } else {
        callback();
      }
    };
    return {
      localUserInfo: this.$store.state.userInfo,
      selectListForSignStu,
      User,
      identity_list: [],
      man_status_list: [
        { value: 'yes', label: '已加入'},
        { value: 'no', label: '未加入'},
      ],
      months: [],
      monthsList: [],
      periodsList: [],
      showHistory: false,
      showClassDetail: false,
      historyLoading: false,
      isShowScoreList: false,
      showScoreUserId: 0,
      coachHistoryInfo: {
        coachUser: {},
        ranks: [],
        certificates: [],
        achievemens: [],
        rankList: [],
      },
      list: [],
      visible: false,
      addStuInfo: {},
      classBtnLoaing: false,
      color_list: [],
      classRule,
      classList: [],
      chart_list: [],
      classErrorFlag: false,
      classErrorMsg: "",
      class_obj: {
        c_id: "",
      },
      showAddClass: false,
      dataStatusName: [],
      vuescrollOpt: createScrollOpt(),
      disScrollOpt: createScrollOpt(true),
      signId: this.$route.query.signId,
      momentCover,
      organList: [],
      personnelExamStatus,
      XArr: [],
      CArr: [],
      levelLogo,
      signInfo: {},
      linkmenData: [],
      documentDate: [],
      peopleList: [],
      pieData: Array(6).fill(0),
      verifyFlag: false,
      showChart: false,
      showEdit: false,
      ifDiaShow: false,
      statusUpdate: "",
      rememberMsg: "",
      update: {
        btnLoading: false,
        msg: "",
      },
      curStuInfo: {
        studentSingnInfo: {},
        enrollMap: {},
        report_list: [],
        language_list: [],
        academic_data: [],
        coach_data: [],
        experience_data: [],
        experience_data_not: [],
        playing_data: [],
      },
      paging: {
        start: 0, // 每页从第几条数据开始
        prePage: 1, // 一页多少条数据
        total: 0, // 总页数
        size: 3, // 页码显示限制
        last: true, // 尾页
        next: true, // 下一页
        first: true, // 首页
        previous: true, // 上一页
        jump: true,
      },
      page: 1,
      isLoading: true,
      statuSelList: personnelStatus,
      statusList: [],
      selectVal: {
        matriculate_status: "",
        admit_status: "",
        in_class: "",
        order_way: "",
        intention_class_date: "",
        keywords: "",
        org_id: "",
        identity_id: "",
      },
      dateSelVal: "",
      calssLevelSelVal: "",
      pageLoading: true,
      isShowFlag: false,
      user_id: "",
      suggestionList: [], // 建议列表
      isShowAuditLog: false,
      auditLogList: [],
      isShowAddress: false,
      searchAddressForm: {
        province_id: '',
        city_id: '',
      },
      area_list,
      city_list: [],
    };
  },
  methods: {
    getOrganList() {
      orgList({})
        .then((res) => {
          const { organization } = res.data.result;
          this.organList = organization;
        })
        .catch((err) => {});
    },
    verify(uid) {
      this.isShowFlag = true;
      this.user_id = uid;
    },
    hideVerifyDialog(bool, params, msg) {
      this.isShowFlag = false;
      if (bool) {
        examPersonnelCheck({
          enroll_uuid: this.signId,
          user_id: this.user_id,
          msg_info: msg,
          result: params,
        })
          .then((res) => {
            const { status, msg } = res.data;
            if (Number(status) === 0) {
              this.getPeoples();
              this.getDeatilInfo();
            } else {
              this.$message.error(msg);
            }
          })
          .catch((err) => {
            console.error(err);
          });
      }
    },
    drawPie(pieArr) {
      const chartObj = pieArr.reduce(
        (acc, item, index) => {
          if (Number(item) > 0) {
            acc.data.push({ value: item, name: this.chart_list[index] });
            acc.color.push(this.color_list[index]);
          }
          return acc;
        },
        { data: [], color: [] }
      );

      const pie_option = {
        color: chartObj.color,
        title: {
          //          text: "扇形图",
          x: "left",
          textStyle: {
            color: "#fff",
          },
        },
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} : {c} ({d}%)",
        },
        series: [
          {
            name: "统计比例",
            type: "pie",
            radius: "45%",
            center: ["50%", "50%"],
            data: chartObj.data,
            label: {
              show: true,
              position: "outside",
              formatter: "{b}:{d}%",
            },
          },
        ],
      };
      this.$nextTick(() => {
        const chart = echarts.init(this.$refs["pie"]);
        chart.setOption(pie_option);
      });
    },
    drawBar(barArr) {
      this.$nextTick(() => {
        const chart = echarts.init(this.$refs["bar"]);
        const bar_option = {
          title: {
            //              text: '柱状图',
            // left: 'center',
            textStyle: {
              color: "#fff",
            },
          },
          // color: ['#08cbfe'],
          color: ["#00FF00"],
          grid: {
            left: "2%",
            right: "10%",
            bottom: "0%",
            containLabel: true,
            // borderColor: "#f00",
          },
          tooltip: {
            trigger: "axis",
            axisPointer: {
              type: "shadow",
            },
          },
          xAxis: {
            type: "category",
            name: "类型",
            data: [...this.chart_list],
            axisTick: {
              alignWithLabel: true,
            },
            axisLine: {
              lineStyle: {
                color: "#fff",
              },
            },
            axisLabel: {
              interval: 0,
              rotate: 40,
            },
          },
          yAxis: {
            type: "value",
            name: "人数",
            minInterval: 1,
            axisLine: {
              lineStyle: {
                color: "#fff",
              },
            },
            splitLine: {
              show: false,
            },
          },
          series: [
            {
              name: "人数",
              type: "bar",
              label: {
                show: true,
                // formatter: '{c}人',
                color: "#fff",
                position: "top",
                fontSize: 14,
              },
              barWidth: "30%",
              data: barArr,
            },
          ],
        };
        chart.setOption(bar_option);
      });
    },
    userImgError(idx) {
      this.$set(this.peopleList[idx], "profile_picture", this.User);
    },
    lookSignUp(uid) {
      this.getPersonnelInfo(uid);
      this.ifDiaShow = true;
    },
    getPersonnelInfo(uid) {
      info_view({ uuid: uid, enroll_uuid: this.signInfo.enroll_uuid }).then(
        ({ data }) => {
          if (data.status === 0) {
            const { result } = data;
            this.curStuInfo.studentSingnInfo = {
              ...result.studentSingnInfo,
              id_card_photo_front: result.studentSingnInfo.id_card_photo_front
                ? HOSTURL + result.studentSingnInfo.id_card_photo_front
                : identify1,
              id_card_photo_verso: result.studentSingnInfo.id_card_photo_verso
                ? HOSTURL + result.studentSingnInfo.id_card_photo_verso
                : identify2,
              profile_picture: result.studentSingnInfo.profile_picture
                ? HOSTURL + result.studentSingnInfo.profile_picture
                : avatorImg,
            };
            for (const key in this.studentSingnInfo) {
              if (this.studentSingnInfo.hasOwnProperty(key)) {
                const element = this.studentSingnInfo[key];
                this.studentSingnInfo[key] = element || "--";
              }
            }
            this.curStuInfo.language_list = [...result.language_list];
            this.curStuInfo.academic_data = [...result.academic_data];
            this.curStuInfo.coach_data = [...result.coach_data];
            this.curStuInfo.experience_data = [...result.experience_data];
            this.curStuInfo.experience_data_not = [
              ...result.experience_data_not,
            ];
            this.curStuInfo.playing_data = [...result.playing_data];
            this.curStuInfo.enrollMap = { ...result.enrollMap };
            this.curStuInfo.report_list = [...result.report_list];
            // experienceFilter 方法替代了部分数据

          } else {
          }
        }
      );
    },
    get_identity_ids(level) {
      personnel_identity_data({
        level: level,
      }).then((res) => {
        if (Number(res.data.status) === 0) {
          const { list } = res.data.result;
          !!list.length && (this.identity_list = list);
        }
      });
    },
    getDeatilInfo() {
      signUpDetail({ enroll_uuid: this.signId }).then(
        ({ data: { result, status } }) => {
          this.pageLoading = false;
          this.getChartData();
          if (status === 0) {
            this.signInfo = {
              ...result.enrollInfo,
              classPhase: result.classPhase,
              personnelNum: result.personnelNum,
              isShowClose: result.isShowClose,
              isShowOpen: result.isShowOpen,
            };
            this.linkmenData = [...result.linkmenData];
            this.documentDate = [...result.documentDate];
            // this.CArr=this.signInfo.enroll_type==='make_up_exam'? newColorArr : colorArr;
            // this.XArr=this.signInfo.enroll_type==='make_up_exam'? newChartXArr : chartXArr;
            // this.selectVal.matriculate_status=this.signInfo.enroll_type==='make_up_exam' ? "":"personnelThrough";
            // this.statuSelList=this.signInfo.enroll_type==='make_up_exam'? personnelExamStatus : personnelStatus
            if (
              result.enrollInfo.enroll_status !== "enrollFinalised" &&
              result.enrollInfo.enroll_status !== "enrollComplete"
            ) {
              this.showEdit = true;
            }
            if (result.enrollInfo.enroll_type === "common") {
              this.get_identity_ids(result.enrollInfo.enroll_level);
            }
            let class_starts = this.$yioks.time(this.signInfo.class_start);
            let class_ends = this.$yioks.time(this.signInfo.class_end);
            this.months = this.$yioks.getMonthBetween(class_starts, class_ends);

            this.monthsList = [];
            this.periodsList = [];
            const { classPhase } = result;
            if (classPhase.length && this.signInfo.time_change_way ==='month') {
              classPhase.forEach((item) => {
                const { start_date, end_date } = item;
                const momentJs = require("moment");
                // let tentionMonthList = {
                //   label: `${momentJs(start_date).format('yyyy-MM')} 至 ${momentJs(end_date).format('yyyy-MM')}`,
                //   // value: JSON.stringify(item),
                //   // value: `${momentJs(start_date).format('yyyy-MM')} 至 ${momentJs(end_date).format('yyyy-MM')}`,
                // }
                const lebelName = `${momentJs(start_date).format(
                  "yyyy-MM"
                )} 至 ${momentJs(end_date).format("yyyy-MM")}`;
                for (let i = 0; i < 1; i++) {
                  const seq = ["一", "二"];
                  const tentionMonthList = {
                    label: `${lebelName}`,
                    value: JSON.stringify({
                      intention_class_date: lebelName,
                    }),
                  };
                  this.monthsList.push(tentionMonthList);
                }
              });
            }
            if (classPhase.length && this.signInfo.time_change_way ==='periods') {
              classPhase.forEach((item,index) => {
                const { start_date, end_date,start_date_two,end_date_two,province_name,city_name } = item;
                const momentJs = require("moment");
                let lebelName = '选择'+`${index+1}`+'（阶段一：'+`${momentJs(start_date).format("yyyy-MM")}，阶段二：${momentJs(end_date).format("yyyy-MM")}`;
                let value1 = `${index+1}`+','+`${momentJs(start_date).format("yyyy-MM")},${momentJs(end_date).format("yyyy-MM")}`;
  
                if(start_date_two){
                  lebelName = '选择'+`${index+1}`+'（阶段一：'+`${momentJs(start_date).format("yyyy-MM-DD")} 至 ${momentJs(end_date).format("yyyy-MM-DD")}，阶段二：${momentJs(start_date_two).format("yyyy-MM-DD")} 至 ${momentJs(end_date_two).format("yyyy-MM-DD")}`;
                  value1 = `${index+1}`+','+`${momentJs(start_date).format("yyyy-MM-DD")}至${momentJs(end_date).format("yyyy-MM-DD")},${momentJs(start_date_two).format("yyyy-MM-DD")}至${momentJs(end_date_two).format("yyyy-MM-DD")}`;
                }
                if(province_name){
                  lebelName = lebelName + "，" + province_name + city_name;
                  value1 = value1 + "," + province_name + city_name;
                }
                lebelName = lebelName+'）';
                
                for (let i = 0; i < 1; i++) {
                  const seq = ["一", "二"];
                  const tentionMonthList = {
                    label: `${lebelName}`,
                    value: JSON.stringify({
                      intention_class_date: value1,
                    }),
                  };
                  this.periodsList.push(tentionMonthList);
                }
              });
            }
          }
        }
      );
    },
    getPeoples() {
      this.isLoading = true;
      let submitData = {
        enroll_uuid: this.signId,
        page: this.page,
        keywords: this.selectVal.keywords,
        in_class: this.selectVal.in_class,
        order_way: this.selectVal.order_way,
        org_id: this.selectVal.org_id,
        identity_id: this.selectVal.identity_id,
        matriculate_status: this.selectVal.matriculate_status,
        admit_status: this.selectVal.admit_status,

        province_id: this.searchAddressForm.province_id,
        city_id: this.searchAddressForm.city_id,
      };

      /*
      searchAddressForm: {
        province_id: '',
        city_id: '',
      }, */
      if (this.selectVal.intention_class_date) {
        const { intention_class_date, intention_num } = JSON.parse(
          this.selectVal.intention_class_date
        );
        submitData = {
          ...submitData,
          intention_class_date,
          intention_num,
        };
      } else {
        submitData = {
          ...submitData,
          intention_class_date: "",
          intention_num: "",
        };
      }
      signUpPeoples(submitData)
        .then(({ data: { result, status } }) => {
          this.isLoading = false;
          if (status === 0) {
            this.$set(this.paging, "prePage", result.page.page_size);
            this.$set(this.paging, "total", result.page.total_row);
            this.$set(
              this.paging,
              "start",
              (this.page - 1) * this.paging.prePage
            );
            this.peopleList = result.list.map((item) => {
              const { admit_note, ...other } = item;
              return {
                ...other,
                admit_note: admit_note ? JSON.parse(admit_note) : [],
                inputVisible: false,
                inputValue: "",
              };
            });
          }
        })
        .catch((err) => {
          this.isLoading = false;
          console.error(err);
        });
    },
    // 仅用来更新报名人员数据；（不包含loading组件逻辑，避免出现页面刷新的状态，）
    getPeoplesWithNoLoading() {
      let submitData = {
        enroll_uuid: this.signId,
        page: this.page,
        keywords: this.selectVal.keywords,
        org_id: this.selectVal.org_id,
        in_class: this.selectVal.in_class,
        order_way: this.selectVal.order_way,
        identity_id: this.selectVal.identity_id,
        matriculate_status: this.selectVal.matriculate_status,
        admit_status: this.selectVal.admit_status,

        province_id: this.searchAddressForm.province_id,
        city_id: this.searchAddressForm.city_id,
      };
      if (this.selectVal.intention_class_date) {
        const { intention_class_date, intention_num } = JSON.parse(
          this.selectVal.intention_class_date
        );
        submitData = {
          ...submitData,
          intention_class_date,
          intention_num,
        };
      } else {
        submitData = {
          ...submitData,
          intention_class_date: "",
          intention_num: "",
        };
      }
      signUpPeoples(submitData)
        .then(({ data: { result, status } }) => {
          if (status === 0) {
            this.peopleList = result.list.map((item) => {
              const { admit_note, ...other } = item;
              return {
                ...other,
                admit_note: admit_note ? JSON.parse(admit_note) : [],
                inputVisible: false,
                inputValue: "",
              };
            });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    getChartData() {
      signUpChart({ enroll_uuid: this.signId }).then(
        ({
          data: {
            result: { dataPersonnel, dataStatusName },
            status,
          },
        }) => {
          if (status === 0) {
            this.chart_list = [];
            this.color_list = [];
            this.statusList = [];
            this.showChart = !dataPersonnel.every((item) => item === 0);
            this.dataStatusName = dataStatusName;
            this.dataStatusName.forEach((item, index) => {
              this.statusList.push({
                key: statusKV[item].text,
                value: item,
              });
              this.chart_list.push(statusKV[item].text);
              this.color_list.push(statusKV[item].color);
            });
            if (!this.showChart) {
              return;
            }
            this.drawPie(dataPersonnel);
            this.drawBar(dataPersonnel);
          }
        }
      );
    },
    gotoPage(start) {
      this.page = parseInt(start / this.paging.prePage) + 1;
      this.changeQuery(false);
      // this.$refs['vs'].scrollTo({ y: 0 });
    },
    toEdit() {
      this.$router.push("/system/edit_sign_up/" + this.signId);
    },
    downloadFile(url) {
      downfile(url);
    },
    enrollClose(status) {
      this.verifyFlag = true;
      // this.update.btnLoading=true;
      this.statusUpdate = status;
      this.update.msg =
        status === "open" ? "确定开启该报名吗？" : "确定关闭该报名吗？";
    },
    hideUploadTips(bool, flag) {
      if (flag) {
        this.update.btnLoading = true;
        enrollClose({ enroll_uuid: this.signId, status: this.statusUpdate })
          .then((res) => {
            const { status, msg } = res.data;
            if (Number(status) === 0) {
              this.getDeatilInfo();
              this.$message.success(
                this.status === "open" ? "开启成功" : "关闭成功"
              );
              // this.verifyFlag = false;
              this.update.btnLoading = false;
              this.verifyFlag = false;
            } else {
              this.$message.error(msg);
            }
          })
          .catch((err) => {
            console.error(err);
          });
      } else {
        this.verifyFlag = false;
      }
    },
    tranHisView(uid) {
      if (this.showHistory) return;
      this.showHistory = true;
      this.getStuHistoryTrianList(uid);
    },
    getStuHistoryTrianList(uid) {
      this.list = [];
      this.historyLoading = true;
      getStuHistoryTrian({
        uid,
      })
        .then((res) => {
          const { result } = res.data;

          if (result.coachHistoryInfo) {
            const { coachUser, ranks, certificates, achievemens, score } =
              result.coachHistoryInfo;
            if (coachUser) this.coachHistoryInfo.coachUser = coachUser; // 获取用户信息
            if (ranks) this.coachHistoryInfo.ranks = ranks; // 获取等级
            if (certificates) this.coachHistoryInfo.certificates = certificates; //获取证书
            if (achievemens) this.coachHistoryInfo.achievemens = achievemens; //获取成绩信息
            // 处理证书
            let certificateInfo = {};
            if (certificates.length > 0) {
              for (let i = 0; i < certificates.length; i++) {
                const { rankId } = certificates[i];
                certificateInfo[rankId] = certificates[i];
              }
            }
            // 处理成绩
            let achievemensInfo = {};
            if (achievemens.length > 0) {
              for (let i = 0; i < achievemens.length; i++) {
                const { rankId } = achievemens[i];
                achievemensInfo[rankId] = achievemens[i];
              }
            }
            // 合并成绩
            if (ranks.length > 0) {
              for (let j = 0; j < ranks.length; j++) {
                const { id } = ranks[j];
                if (score && score[achievemensInfo[id]["id"]]) {
                  ranks[j]["score"] = score[achievemensInfo[id]["id"]];
                }
                ranks[j].is_old = 1;
                if (certificateInfo[id]) {
                  const {
                    certificateNum,
                    certificateDate,
                    validityStart,
                    certificateUrl,
                  } = certificateInfo[id];
                  ranks[j].certificateNum = certificateNum;
                  ranks[j].certificateDate = certificateDate;
                  ranks[j].validityStart = validityStart;
                  if (certificateUrl) ranks[j].certificateUrl = certificateUrl;
                }
                if (achievemensInfo[id]) {
                  const {
                    classAddress,
                    classEnd,
                    classStart,
                    lecturerName,
                    classUid,
                    continueCumulativeHours,
                  } = achievemensInfo[id];
                  ranks[j].classAddress = classAddress;
                  ranks[j].classEnd = classEnd;
                  ranks[j].classStart = classStart;
                  ranks[j].lecturerName = lecturerName;
                  ranks[j].classUid = classUid;
                  ranks[j].continueCumulativeHours = continueCumulativeHours;
                  ranks[j].end_date = new Date(classEnd).getTime();
                  this.list.push(ranks[j]);
                }
              }
            }

            if (this.list)
              this.list = this.list.sort((pre, next) => {
                return next.end_date - pre.end_date;
              });
          }
          this.historyLoading = false;
        })
        .catch((err) => {
          console.error(err);
        });
    },
    changeQuery(flag) {
      flag && (this.page = 1);
      let queryData = {
        ...this.$route.query,
        ...this.searchAddressForm,
        enroll_level: this.selectVal.enroll_level,
        matriculate_status: this.selectVal.matriculate_status,
        keywords: this.selectVal.keywords,
        org_id: this.selectVal.org_id,
        in_class: this.selectVal.in_class,
        order_way: this.selectVal.order_way,
        page: this.page,
        identity_id: this.selectVal.identity_id,
        admit_status: this.selectVal.admit_status,
        // intention_class_date:this.selectVal.intention_class_date,
      };
      if (this.selectVal.intention_class_date) {
        const { intention_class_date, intention_num } = JSON.parse(
          this.selectVal.intention_class_date
        );
        queryData = {
          ...queryData,
          intention_class_date,
          intention_num,
        };
      } else {
        queryData = {
          ...queryData,
          intention_class_date: "",
          intention_num: "",
        };
      }
      this.$router.replace({
        path: this.$route.path,
        query: queryData,
      });
      this.getPeoples();
    },
    submitClass() {
      this.visible = false;
      this.$refs["classForm"].validate((valid) => {
        if (valid) {
          this.classBtnLoaing = true;
          add_student_toClass({
            c_id: this.class_obj.c_id,
            student_list: JSON.stringify([
              {
                id: 0,
                enroll_uuid: this.addStuInfo.enroll_uuid,
                user_id: this.addStuInfo.user_id,
                enroll_type: this.addStuInfo.enroll_type,
                id_number: this.addStuInfo.id_number,
              },
            ]),
          })
            .then((res) => {
              if (Number(res.data.status) === 0) {
                const { consequence, studentErr, stuErr } = res.data.result;
                if (consequence === "OK") {
                  this.$message.success("加入培训班成功");
                  this.getPeoples();
                  this.classErrorFlag = false;
                  this.showAddClass = false;
                  this.classErrorMsg = "";
                } else {
                  this.classErrorFlag = true;
                  if (stuErr) {
                    this.classErrorMsg = stuErr;
                  } else {
                    this.classErrorMsg = Object.values(studentErr[0].err).join(
                      ","
                    );
                  }
                  this.$refs["classForm"].validateField("c_id");
                }
                this.classBtnLoaing = false;
              } else {
                this.classErrorMsg = res.data.msg;
                this.classErrorFlag = true;
                this.classBtnLoaing = false;
                this.$refs["classForm"].validateField("c_id");
              }
            })
            .catch((err) => {
              this.showAddClass = false;
              this.classBtnLoaing = false;
            });
        } else {
          this.classBtnLoaing = false;
          this.$message.error("请选择需要加入的培训班");
        }
      });
    },
    search() {
      this.changeQuery(true);
    },
    handleIntentionChange(val) {
      this.search();
    },
    handleAdmitStatus(val) {
      this.search();
    },
    hideIcon() {
      this.$set(this.selectVal, "keywords", "");
      this.changeQuery(true);
    },
    setData() {
      const {
        page,
        create_time,
        matriculate_status,
        keywords,
        org_id,
        identity_id,
        intention_class_date,
        intention_num,
        admit_status,
        province_id,
        in_class,
        order_way,
        city_id,
      } = this.$route.query;
        // province_id: this.searchAddressForm.province_id,
        // city_id: this.searchAddressForm.city_id,
      page && (this.page = page);
      create_time && (this.dateSelVal = create_time);
      matriculate_status &&
        this.$set(this.selectVal, "matriculate_status", matriculate_status);
      intention_class_date &&
        intention_num &&
        this.$set(
          this.selectVal,
          "intention_class_date",
          JSON.stringify({ intention_class_date, intention_num })
        );
      keywords && this.$set(this.selectVal, "keywords", keywords);
      in_class && this.$set(this.selectVal, "in_class", in_class);
      order_way && this.$set(this.selectVal, "order_way", order_way);
      org_id && this.$set(this.selectVal, "org_id", org_id);
      identity_id && this.$set(this.selectVal, "identity_id", identity_id);
      admit_status && this.$set(this.selectVal, "admit_status", admit_status);

      province_id && this.$set(this.searchAddressForm, "province_id", province_id);
      this.city_list = this.$yioks.updateCity(province_id, this.area_list);
      city_id && this.$set(this.searchAddressForm, "city_id", city_id);
    },
    addClass(item) {
      this.addStuInfo = item;
      if (this.showAddClass) return;
      this.showAddClass = true;
      this.getClassList(item.enroll_level, item.enroll_type);
    },
    getClassList(level, enroll_type) {
      noStartClassTrainList({
        level,
        enroll_type,
      })
        .then((res) => {
          if (res.data.status === 0) {
            const { classList } = res.data.result;
            this.classList = classList;
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    if_has_audit_btn(item) {
      switch (item.matriculate_status) {
        case "examPersonnel":
          return true;
          break;
        case "teacherPersonnel":
          return true;
          break;
        case "personnelThrough":
        case "organThrough":
//          if (
//            item.enroll_level === "P" ||
//            item.enroll_level === "PRO" ||
//            item.enroll_level === "0"
//          ) {
//            return true;
//          }
          return false;
          break;
      }
      return false;
    },
    if_has_class_btn(item) {
      if (['B','A','PRO','F1','F2'].includes(item.enroll_level) || ['continue_education','teacher_train','physical_train','goalkeeper_train','goalkeeper_education'].includes(this.signInfo.enroll_type)) {
        if(this.signInfo.enroll_type === 'continue_education') {
          if(this.signInfo.train_way.includes("offline")){
            return true;
          }
        }

        if (['examThrough','examPersonnel','personnelThrough','onlineAdmit','organThrough','teacherThrough'].includes(item.matriculate_status)){
          return true;
        }
        return false;
      } else {
        return false;
      }
    },
    jumpLookClass(c_id) {
      this.$router.push({
        path: "class_detail",
        query: {
          c_id,
        },
      });
    },
    ShowScoreList(item){
      if(item.total_score){
        this.showScoreUserId = item.user_id
        this.isShowScoreList = true;
      } else{
        this.$message.error("学员暂无积分明细")
      }
    },
    // el-tag输入完成
    handleInputConfirm(item, index) {
      let inputValue = item.inputValue;
      if (inputValue) {
        item.admit_note.push(inputValue);
        this.ajaxForTag(item, index);
      }
      item.inputVisible = false;
      item.inputValue = "";
    },
    // 显示el-tag输入框
    showInput(item, index) {
      item.inputValue = "";
      item.inputVisible = true;
      this.$nextTick((_) => {
        this.$refs.saveTagInput[0].$refs.input.focus();
      });
    },
    ajaxForTag(item, index) {
      const { admit_note, personnel_id } = item;
      const postData = {
        personnel_id,
        admit_note: JSON.stringify(admit_note),
      };
      add_tags(postData)
        .then(({ data }) => {
          if (data.status !== 0) {
            this.$message.error("备注标签添加失败");
            return;
          }
          // 刷新报名人员数据
          this.getPeoplesWithNoLoading();
        })
        .catch((err) => {
          console.error("err", err);
        });
    },
    handleClose(item, index) {
      item.admit_note.splice(index, 1);
      this.ajaxForTag(item, index);
    },

    handleChangeStuAdminStatus(item, index) {
      const { admit_status, personnel_id } = item;
      const postData = {
        personnel_id,
        admit_status: admit_status ? admit_status : "",
      };
      toggle_admit_status(postData)
        .then(({ data }) => {
          if (data.status !== 0) {
            this.$message.error(data.msg);
            return;
          }
          this.getPeoplesWithNoLoading();
        })
        .catch((err) => {
          console.error("err", err);
        });
    },
    querySearch(queryString, cb) {
      let searchSuggestion =
        yioksStorage.getItem(SELECTSUGGESTIONlIST) || this.suggestionList;
      if (searchSuggestion && searchSuggestion.length) {
        if (queryString) {
          const filtersList = searchSuggestion.filter((str) => {
            return (
              str.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0
            );
          });
          cb(filtersList);
        } else {
          cb(searchSuggestion);
        }
      } else {
        cb([]);
      }
    },
    handleSearch(row) {
      let searchSuggestion = yioksStorage.getItem(SELECTSUGGESTIONlIST);
      if (searchSuggestion && searchSuggestion.length) {
        const isExit = searchSuggestion.some((item) => {
          return item.value == row.value;
        });
        if (row.value && !isExit) {
          if (searchSuggestion.length >= 10) {
            searchSuggestion.shift();
          }
          searchSuggestion.push(item);
          yioksStorage.setItem(SELECTSUGGESTIONlIST, searchSuggestion);
          this.suggestionList = searchSuggestion;
        }
      }
      this.search();
    },

    handleBtnSearch() {
      const { keywords } = this.selectVal;
      if (keywords) {
        let searchSuggestion = yioksStorage.getItem(SELECTSUGGESTIONlIST) || [];
        const isExit = searchSuggestion.some((item) => {
          return item.value === keywords;
        });
        if (!isExit) {
          if (searchSuggestion.length >= 10) searchSuggestion.shift();
          searchSuggestion.push({
            value: keywords,
          });
          this.suggestionList = searchSuggestion;
          yioksStorage.setItem(SELECTSUGGESTIONlIST, this.suggestionList);
        }
      }
      this.search();
    },

    // 获取审核记录
    loadAuditLog(row) {
      const { enroll_id, user_id } = row;
      const params = {
        enroll_id,
        user_id,
      };
      findAuditLogForSys(params)
        .then(({ data }) => {
          if (data.status !== 0) {
            this.$message.error(data.msg);
            return;
          }
          return data.result;
        })
        .then((data) => {
          const { history } = data;
          this.auditLogList = history && history.length ? history : [];
          this.isShowAuditLog = true;
        })
        .catch((err) => {
          console.error("err", err);
        });
    },

    handleLogCallBack() {
      this.isShowAuditLog = false;
    },

    updateCity(val) {
      if(val) {
        this.city_list = this.$yioks.updateCity(val, this.area_list)
        this.searchAddressForm.city_id = this.city_list[0].id
      } else {
        this.city_list = []
        this.searchAddressForm.city_id = ''
      }
    },
    handleSearchAddress() {
      this.changeQuery(true);
      this.isShowAddress = false;
    },
    handleClearSearchAddress() {
      this.$set(this.searchAddressForm, 'province_id', '')
      this.$set(this.searchAddressForm, 'city_id', '')
      this.changeQuery(true);
      this.isShowAddress = false;
    },
  },
  filters: {
    experienceFilter,
    intention_class_date_periods_filter,
    getGender(gender) {
      return gender === "Male" ? "男" : "女";
    },
    enrollLogo(level) {
      const enrollLevel = {
        A: levelA,
        B: levelB,
        Pro: levelPro,
      };
      return enrollLevel[level];
    },
    enrollLevel(level) {
      return classLevelForNewUser(level);
    },
    enrollType(type) {
      return enroll_type(type);
    },
    enroll_train_way(type) {
      return enroll_train_way(type);
    },
    tipMsg(is_not_score_stu, is_score_unusual_stu, is_license_expired) {
      let msg = "";
      if (is_not_score_stu === 1) {
        msg += "成绩库中暂无该报名人员上一级别记录、";
      }
      if (is_score_unusual_stu === 1) {
        msg += "成绩库中该报名人员成绩异常、";
      }
      if (is_license_expired === 1) {
        msg += "成绩库中该报名人员证书已过期、";
      }
      msg = msg.substr(0, msg.length - 1);
      return msg;
    },
    intentionClassDate(dates) {
      let str = "";
      if (dates && dates !== "[]") {
        const dataList = JSON.parse(dates);
        for (let i = 0; i < dataList.length; i++) {
          str += dataList[i] + "，";
        }
        if (str !== "") {
          str = str.substring(0, str.length - 1);
        } else {
          str = "--";
        }
      } else {
        str = "--";
      }
      return str;
    },
  },
  watch: {
    showAddClass: {
      handler(val) {
        if (!val) {
          this.$set(this.class_obj, "c_id", "");
        }
      },
    },
  },

  destroyed() {
    // 离开即清空
    // yioksStorage.clearItem(SELECTSUGGESTIONlIST);
  },
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/css/variable'
@import '~@/assets/css/mixin'
.sign_up_detail-root
  zuxie-page-root()
  .main-content-wrap
    color $color_white
    font-size $font_size_medium
    line-height inherit
    .pageLoading_top
      .loading-wrap-root
        top 280px
    .nav-wrap
      margin-bottom 25px
      .title
        line-height 1.2
        font-size $font_size_big
  .sign_up-info-wrap
    display flex
    align-items center
    margin-bottom 10px
    padding 0 20px
    background-color $block_bg_color_base
    .info-box
      padding 20px 0
      flex 1
      display flex
      align-items flex-start
      .show-wrap
        flex none
        position relative
        z-index 10
        width 130px
        height 130px
        margin-right 15px
        cursor pointer
        .picture
          display block
          width 100%
          height 100%
        .status-flat
          left 3px
          top 8px
      .detail-info
        font-size $font_size_medium
        flex 1
        .info-item
          margin-bottom 0.35em
    .btns_wrap
      .zuxie-btn
        &+.zuxie-btn
          margin-left 10px
  .deatil_main
    display block
    width 100%
    height 460px
    background-color $block_bg_color_base
    .scroll_wrap
      display block
      width 100%
      height 100%
      padding-top 20px
      overflow hidden
      .scroll-content
        display block
        padding 0 19px
        .itemWrap
          margin-bottom 30px
          .loading_wrap
            display block
            position relative
            width 100%
            height 100px
          .titleWrap
            margin-bottom 20px
            display flex
            justify-content space-between
            font-size 20px
            user-select none
            .empty_wrap
              height 100px
              width 100%
            .title
              display flex
              align-items flex-end
              .logo
                margin-right 10px
              p
                line-height 20px
                span
                  margin 0 0 0 10px
                  font-size $font_size_medium
            select
              font-size $font_size_medium
              height 34px
              border 1px solid #999
              padding 0 10px
              outline 0
              color #000
              position relative
              // top 6px
            .selectWith
              // width 90px
              width 100%
              flex 1
              &+.selectWith
                margin-left 10px
            .selectWidth3
              width 100%
              flex 1
              &+.selectWidth3
                margin-left 10px
            .search
              height 1
              position relative
              margin-left 10px
              // top 6px
              display flex
              justify-content flex-end
              .wrap
                height 100%
                position relative
                input
                  width 150px
                  height 100%
                  padding 0 20px 0 10px
                  font-size $font_size_medium
                  color $color_black
                  outline none
                .close
                  position absolute
                  right 3px
                  top 6px
                  color $color_info
                  cursor pointer
              .searchBtn
                width 80px
                box-sizing border-box
                display flex
                justify-content center
                align-items center
                font-size 18px
                background-color $color_suc
                cursor pointer
                user-select none
          .chart_wrap
            width 100%
            height 230px
            margin 0 0 30px 0
            display flex
            .pie
              width 45%
              padding-right 5px
              height 100%
              border-right 1px solid $color_white
              box-sizing border-box
            .bar
              width 55%
              height 100%
              padding-left 5px
          .table
            // .empty_wrap
            // height 200px;
            // width 100%
            .empty_wrap
              margin-top 35px
            .item
              margin 0 0 20px 0
              border 1px solid $color_white
              .row
                display flex
                .col
                  // flex 1 1 auto
                  border-right 1px solid $color_white
                  &:last-child
                    border-right none
                  .btn
                    padding 5px 12px
                    background-color $color_suc
                    border-radius 5px
                    cursor pointer
                    user-select none
                    font-size 14px
                &.up
                  // height: 80px;
                  // border-bottom 1px solid $color_white
                  .col
                    // height: 100%;
                    &.user
                      width 30%
                      display flex
                      justify-content center
                      align-items center
                      padding-left 5px
                      .imgWrap
                        position relative
                        cursor pointer
                        flex none
                        img
                          margin-left 20px
                        .status-flat
                          left -7px
                          top 3px
                          line-height 1.2
                      img
                        flex 0 0 auto
                        width 60px
                        height 60px
                        border-radius 50%
                      .wrap
                        // height: 100%;
                        margin 0 0 0 10px
                        display flex
                        flex-direction column
                        justify-content space-around
                        align-items center
                        width 100%
                        .name
                          font-size $font_size_medium
                          // word-break break-word
                          word-break break-all
                          word-wrap break-word
                          margin-bottom 5px
                          width 100%
                          text-align center
                    .title
                      flex 0 0 auto
                      width 30px
                      // height: 100%;
                      display flex
                      flex-direction column
                      justify-content center
                      align-items center
                      border-right 1px solid $color_white
                    &.info
                      width 25%
                      display flex
                      .block
                        flex 1 1 auto
                        display flex
                        flex-direction column
                        .line
                          flex 1 1 auto
                          padding 0 0 0 20px
                          display flex
                          align-items center
                          font-size $font_size_base
                          border-bottom 1px solid $color_white
                          &:last-child
                            border-bottom none
                          span:first-child
                            margin 0 20px 0 0
                    &.grade
                      width 15%
                      display flex
                      align-items center
                      .title
                        height 100%
                      .gradeStatus
                        flex 1 1 auto
                        text-align center
                        // display flex
                        // justify-content center
                        // align-items center
                        // font-size $font_size_medium
                    &.note
                      width 14%
                      display flex
                      align-items center
                      .text
                        flex 1 1 auto
                        text-align center
                        // font-size $font_size_medium
                        // margin 0 10px
                        // color $color_black
                        // resize none
                    &.look
                      width 15%
                      display flex
                      align-items center
                      justify-content center
                      flex-direction column
                &.down
                  border-top 1px solid #fff
                  line-height 25px
                  font-size $font_size_small
                  .remember
                    margin-left 30px
                    font-size $font_size_medium
            .repetition_stu
              border 1px solid $color_tip_red
            .unusual_err_stu
              border 1px solid $color_unusual
            .both_err_stu
              border 1px solid $color_both_err
          .classInfo
            font-size $font_size_big
            border 1px solid $color_white
            .row
              // height 50px
              display block
              padding 10px
              border-bottom 1px solid $color_white
              .col
                display flex
                .intro
                  min-width 55px
                .downfile
                  cursor pointer
                  color #4cd964
              &:last-child
                border-bottom none
          .connect
            font-size $font_size_big
            border 1px solid $color_white
            .row
              // height 50px
              padding 10px
              // padding 0 0 0 20px
              display flex
              align-items center
              border-bottom 1px solid $color_white
              .col
                // flex 1 1 auto
              .name, .phone
                width 30%
              .email
                width 40%
              &:last-child
                border-bottom none
  .detail-info-dia
    .scroll-wrap
      display block
      height 630px
      overflow hidden
      position relative
      .stu-info-box
        display block
        padding 0 15px
        font-size $font_size_medium
.range-item
  margin-right 10px
  &:not(:last-child)::after
    content ''
.tag-wrapper
  padding 3px 5px
  box-sizing border-box
  .flex-center
    display flex
    align-items center
  .tag-item
    height 32px
    line-height 30px
  .tag-item:not(:last-child)
    margin-right 10px
  .input-new-tag
    height 32px
    width 90px
  .button-new-tag
    height 32px
    display flex
    align-items center
    justify-content center
.tag-box
  flex 1
  display flex
  flex-wrap wrap
  .tag-item
    margin-bottom 3px
.img-wrap
  display flex
  flex-direction column
  align-items flex-end
.suc-color
  color $color_suc
.btn-text
  cursor pointer
  user-select none
.live-address
  display flex
  align-items center
  justify-content center
  color $color_suc
  font-size 14px
  height: 34px


.btns-list
  width 60%
  margin 0 auto
  display flex
  align-items center
  justify-content center
  // &:hover
  //   .btn
  //     color red
  .btn
    padding 7px 17px
    cursor pointer
    user-select none
    border-radius 4px
    margin 0 10px
    color #fff
    &.suc
      background-color $color_suc
    &.primary
      background-color $color_primary
</style>

<style lang="stylus">
.gradeStatus
  .select-admit
    .el-input__inner
      height 32px !important
      width 100px !important
.yioks-wrapper
  .inline-input
    height 100%
  .el-input__inner
    height 34px !important
    width 120px !important
    border-radius 0px !important
    border 1px solid rgb(118, 118, 118) !important
    border-right none !important
.sign_up_detail-root
  .__rail-is-horizontal
    display none
</style>
